import { useState } from "react";
import { Download, Search, Trash2, X } from "lucide-react";
import { toast } from "sonner";

import { Button } from "../../ui/button";
import { Images } from "../../Calendar/Calendar";
import { downloadImage } from "../../../Api/api";

const ImageTile = ({
	file,
	image,
	canRemove,
	onRemove,
}: {
	file?: File;
	image?: Images;
	canRemove: boolean;
	onRemove: () => void;
}) => {
	const [enlarge, setEnlarge] = useState<string | null>(null);
	const download = async () => {
		if (!image) return;
		try {
			const response = await downloadImage(image?.url);
			const blob = new Blob([response.data], {
				type: response.headers["content-type"] || "image/jpeg",
			});
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = image?.filename;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			toast("Success", {
				description: "Image downloaded successfully.",
			});
		} catch (error) {
			console.error("Error downloading image:", error);
			toast.error("Error", {
				description: "Unable to download image at the moment",
			});
		}
	};
	return (
		<>
			<Button
				className='p-0 min-w-12 min-h-12 w-12 h-12 relative group overflow-visible'
				variant={"outline"}
			>
				<div
					className='absolute w-0 h-0 opacity-0 group-hover:w-fit group-hover:h-fit group-hover:opacity-100 flex flex-row justify-end items-start -top-3 -right-2 z-[9999]'
					onClick={() => (enlarge ? setEnlarge(null) : onRemove())}
				>
					<div className='p-0.5 hover:text-themeColor bg-gray-300 rounded-full'>
						<X className='min-w-4 min-h-4' />
					</div>
				</div>
				<div
					className='absolute w-0 h-0 opacity-0 z-50 group-hover:w-full group-hover:h-full group-hover:opacity-100 flex flex-row justify-center items-center bg-gray-300/70 duration-150'
					onClick={() =>
						setEnlarge(
							file ? URL.createObjectURL(file) : image ? image?.url : null
						)
					}
				>
					<Search className='min-w-6 min-h-6' />
				</div>
				<div className='flex justify-center items-center overflow-hidden max-h-full max-w-full'>
					<img
						src={file ? URL.createObjectURL(file) : image?.url}
						alt='logo'
						className='object-contain max-h-full max-w-full'
					/>
				</div>
			</Button>
			{enlarge && (
				<EnlargedImage
					isImage={!!image?.url}
					canRemove={canRemove}
					file={file ? URL.createObjectURL(file) : image?.url}
					onClose={() => setEnlarge(null)}
					onRemove={onRemove}
					downloadImage={download}
				/>
			)}
		</>
	);
};

export default ImageTile;

function EnlargedImage({
	file,
	isImage,
	onClose,
	downloadImage,
	// canRemove,
	onRemove,
}: {
	isImage: boolean;
	file?: string | null;
	canRemove: boolean;
	onRemove: () => void;
	downloadImage: () => void;
	onClose: () => void;
}) {
	return (
		<div className='absolute top-0 right-0 z-[99999999] flex justify-center items-center  h-screen w-screen bg-black/40'>
			<div className='max-h-fit max-w-fit relative group  pb-1 rounded-xl flex justify-center items-center'>
				{file && (
					<>
						<div
							className='absolute w-fit h-fit opacity-100 flex flex-row justify-end items-start -top-3 -right-2 z-[9999]'
							onClick={onClose}
						>
							<Button className='p-0.5 bg-gray-200 rounded-full hover:bg-gray-100 w-8 h-8 text-black border-2 border-gray-300'>
								<X className='min-w-6 min-h-6' />
							</Button>
						</div>
						<img
							src={file}
							alt='logo'
							className='object-contain max-h-[60vh]'
						/>
						<div
							className='absolute w-fit h-fit opacity-100 flex flex-row justify-end items-start bottom-3 right-2 gap-x-2 z-[9999]' //'w-fit ml-auto bg-white flex flex-row justify-end items-start z-[9999] py-2 gap-x-4 px-4 rounded-b-lg'
						>
							{/* {canRemove && ( */}
							{/* )} */}
							{isImage && (
								<>
									<Button
										className='p-2 bg-gray-200 rounded-full hover:bg-gray-100 w-10 h-10 text-black border-2 border-gray-300'
										onClick={onRemove}
									>
										<Trash2 className='min-w-6 min-h-6' />
									</Button>
									<Button
										className='p-2 bg-gray-200 rounded-full hover:bg-gray-100 w-10 h-10 text-black border-2 border-gray-300'
										onClick={downloadImage}
									>
										<Download className='min-w-6 min-h-6' />
									</Button>
								</>
							)}
						</div>
					</>
				)}
			</div>
		</div>
	);
}
